import { FlexBox } from '@dixa/lib-shared-habla';
import { ConversationRatingEligibilityEvaluationResults } from 'lib-shared-types-api';

import { GeneralIneligibleBanner } from './csatFilterEvaluationResults/components';
import { FilterEvaluationList } from './csatFilterEvaluationResults/components/filterEvaluationList';

type FilterEvaluationProps = {
  filterEvaluationResults: ConversationRatingEligibilityEvaluationResults;
};

/**
 * Displays CSAT filter evaluation results as expandable content. This is a pure
 * presentation component meant to be rendered as children within a LogEntry
 * component.
 */
export const FilterEvaluation = ({
  filterEvaluationResults,
}: FilterEvaluationProps): JSX.Element => {
  const hasGeneralIneligibleReasons =
    filterEvaluationResults.generalIneligibleReasons &&
    filterEvaluationResults.generalIneligibleReasons.length > 0;

  return (
    <FlexBox
      padding="300 0"
      margin="0 0 0 500"
      gap="200"
      flexDirection="column"
    >
      {hasGeneralIneligibleReasons && (
        <GeneralIneligibleBanner
          reasons={filterEvaluationResults.generalIneligibleReasons}
        />
      )}

      <FilterEvaluationList evaluationData={filterEvaluationResults} />
    </FlexBox>
  );
};
